module.exports = __webpack_public_path__ + "img/icon_robot.7a6f25de.png";